/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './blood-bank-request.reducer';

export const BloodBankRequest = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const bloodBankRequestList = useAppSelector(state => state.bloodBankRequest.entities);
  const loading = useAppSelector(state => state.bloodBankRequest.loading);
  const totalItems = useAppSelector(state => state.bloodBankRequest.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="blood-bank-request-heading" data-cy="BloodBankRequestHeading">
        <Translate contentKey="tinyMedicRestApp.bloodBankRequest.home.title">Blood Bank Requests</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.bloodBankRequest.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/blood-bank-request/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.bloodBankRequest.home.createLabel">Create new Blood Bank Request</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.bloodBankRequest.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {bloodBankRequestList && bloodBankRequestList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankRequest.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('bloodType')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankRequest.bloodType">Blood Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bloodType')} />
                </th>
                <th className="hand" onClick={sort('rhType')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankRequest.rhType">Rh Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('rhType')} />
                </th>
                <th className="hand" onClick={sort('productType')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankRequest.productType">Product Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('productType')} />
                </th>
                <th className="hand" onClick={sort('requestedDate')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankRequest.requestedDate">Requested Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('requestedDate')} />
                </th>
                <th className="hand" onClick={sort('dispatchedDate')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankRequest.dispatchedDate">Dispatched Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dispatchedDate')} />
                </th>
                <th className="hand" onClick={sort('unitsRequested')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankRequest.unitsRequested">Units Requested</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('unitsRequested')} />
                </th>
                <th className="hand" onClick={sort('unitsDispatched')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankRequest.unitsDispatched">Units Dispatched</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('unitsDispatched')} />
                </th>
                <th className="hand" onClick={sort('reason')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankRequest.reason">Reason</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('reason')} />
                </th>
                <th className="hand" onClick={sort('requesterId')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankRequest.requesterId">Requester Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('requesterId')} />
                </th>
                <th className="hand" onClick={sort('requesterType')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankRequest.requesterType">Requester Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('requesterType')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankRequest.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankRequest.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankRequest.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankRequest.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankRequest.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('transfused')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankRequest.transfused">Transfused</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('transfused')} />
                </th>
                <th className="hand" onClick={sort('ipNumber')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankRequest.ipNumber">Ip Number</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('ipNumber')} />
                </th>
                <th className="hand" onClick={sort('indications')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankRequest.indications">Indications</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('indications')} />
                </th>
                <th className="hand" onClick={sort('uhid')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankRequest.uhid">Uhid</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('uhid')} />
                </th>
                <th className="hand" onClick={sort('entityType')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankRequest.entityType">Entity Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('entityType')} />
                </th>
                <th className="hand" onClick={sort('entityId')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankRequest.entityId">Entity Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('entityId')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.bloodBankRequest.bank">Bank</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.bloodBankRequest.forPatient">For Patient</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.bloodBankRequest.status">Status</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.bloodBankRequest.productComponent">Product Component</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {bloodBankRequestList.map((bloodBankRequest, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/blood-bank-request/${bloodBankRequest.id}`} color="link" size="sm">
                      {bloodBankRequest.id}
                    </Button>
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.BloodGroup.${bloodBankRequest.bloodType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.RhType.${bloodBankRequest.rhType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.BloodProducts.${bloodBankRequest.productType}`} />
                  </td>
                  <td>{bloodBankRequest.requestedDate}</td>
                  <td>{bloodBankRequest.dispatchedDate}</td>
                  <td>{bloodBankRequest.unitsRequested}</td>
                  <td>{bloodBankRequest.unitsDispatched}</td>
                  <td>{bloodBankRequest.reason}</td>
                  <td>{bloodBankRequest.requesterId}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.AddedByType.${bloodBankRequest.requesterType}`} />
                  </td>
                  <td>{bloodBankRequest.active ? 'true' : 'false'}</td>
                  <td>{bloodBankRequest.cursor}</td>
                  <td>{bloodBankRequest.lastUpdated}</td>
                  <td>{bloodBankRequest.microSec}</td>
                  <td>{bloodBankRequest.timestampEntry}</td>
                  <td>{bloodBankRequest.transfused ? 'true' : 'false'}</td>
                  <td>{bloodBankRequest.ipNumber}</td>
                  <td>{bloodBankRequest.indications}</td>
                  <td>{bloodBankRequest.uhid}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.EntityType.${bloodBankRequest.entityType}`} />
                  </td>
                  <td>{bloodBankRequest.entityId}</td>
                  <td>
                    {bloodBankRequest.bank ? <Link to={`/blood-bank/${bloodBankRequest.bank.id}`}>{bloodBankRequest.bank.id}</Link> : ''}
                  </td>
                  <td>
                    {bloodBankRequest.forPatient ? (
                      <Link to={`/gluco-user/${bloodBankRequest.forPatient.id}`}>{bloodBankRequest.forPatient.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {bloodBankRequest.status ? (
                      <Link to={`/clinical-dictionary/${bloodBankRequest.status.id}`}>{bloodBankRequest.status.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {bloodBankRequest.productComponent ? (
                      <Link to={`/clinical-dictionary/${bloodBankRequest.productComponent.id}`}>
                        {bloodBankRequest.productComponent.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/blood-bank-request/${bloodBankRequest.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/blood-bank-request/${bloodBankRequest.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/blood-bank-request/${bloodBankRequest.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.bloodBankRequest.home.notFound">No Blood Bank Requests found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={bloodBankRequestList && bloodBankRequestList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default BloodBankRequest;
